/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedActorRouteImport } from './routes/_authenticated-actor'
import { Route as AuthenticatedUserRouteImport } from './routes/_authenticated-user'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as NyBrukerIndexRouteImport } from './routes/ny-bruker/index'
import { Route as AuthenticatedActorSignerIndexRouteImport } from './routes/_authenticated-actor/signer/index'
import { Route as AuthenticatedUserHjelpIndexRouteImport } from './routes/_authenticated-user/hjelp/index'
import { Route as AuthenticatedUserSmsMeldingerIndexRouteImport } from './routes/_authenticated-user/sms-meldinger/index'
import { Route as AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRouteImport } from './routes/_authenticated-user/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/index'
import { Route as AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRouteImport } from './routes/_authenticated-user/hjelp/dodsbo-hjemmelserklaering/index'
import { Route as AuthenticatedUserHjelpKomIGangIndexRouteImport } from './routes/_authenticated-user/hjelp/kom-i-gang/index'
import { Route as AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRouteImport } from './routes/_authenticated-user/hjelp/saker-som-ikke-kan-sendes-elektronisk/index'
import { Route as AuthenticatedUserHjelpTinglysingMedVedleggIndexRouteImport } from './routes/_authenticated-user/hjelp/tinglysing-med-vedlegg/index'
import { Route as AuthenticatedUserHjelpTresidigSkjoteIndexRouteImport } from './routes/_authenticated-user/hjelp/tresidig-skjote/index'
import { Route as AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRouteImport } from './routes/_authenticated-user/hjelp/valideringsfeil-fra-kartverket/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/index'
import { Route as AuthenticatedUserSuperuserAfpantIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/index'
import { Route as AuthenticatedUserSuperuserRapporterIndexRouteImport } from './routes/_authenticated-user/superuser/rapporter/index'
import { Route as AuthenticatedUserSuperuserStatistikkIndexRouteImport } from './routes/_authenticated-user/superuser/statistikk/index'
import { Route as AuthenticatedUserSuperuserTinglysingIndexRouteImport } from './routes/_authenticated-user/superuser/tinglysing/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjoeteId/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRouteImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRouteImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedActorRoute = AuthenticatedActorRouteImport.update({
  id: '/_authenticated-actor',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUserRoute = AuthenticatedUserRouteImport.update({
  id: '/_authenticated-user',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const NyBrukerIndexRoute = NyBrukerIndexRouteImport.update({
  id: '/ny-bruker/',
  path: '/ny-bruker/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedActorSignerIndexRoute =
  AuthenticatedActorSignerIndexRouteImport.update({
    id: '/signer/',
    path: '/signer/',
    getParentRoute: () => AuthenticatedActorRoute,
  } as any)
const AuthenticatedUserHjelpIndexRoute =
  AuthenticatedUserHjelpIndexRouteImport.update({
    id: '/hjelp/',
    path: '/hjelp/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSmsMeldingerIndexRoute =
  AuthenticatedUserSmsMeldingerIndexRouteImport.update({
    id: '/sms-meldinger/',
    path: '/sms-meldinger/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute =
  AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRouteImport.update(
    {
      id: '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/',
      path: '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute =
  AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRouteImport.update({
    id: '/hjelp/dodsbo-hjemmelserklaering/',
    path: '/hjelp/dodsbo-hjemmelserklaering/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserHjelpKomIGangIndexRoute =
  AuthenticatedUserHjelpKomIGangIndexRouteImport.update({
    id: '/hjelp/kom-i-gang/',
    path: '/hjelp/kom-i-gang/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute =
  AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRouteImport.update(
    {
      id: '/hjelp/saker-som-ikke-kan-sendes-elektronisk/',
      path: '/hjelp/saker-som-ikke-kan-sendes-elektronisk/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute =
  AuthenticatedUserHjelpTinglysingMedVedleggIndexRouteImport.update({
    id: '/hjelp/tinglysing-med-vedlegg/',
    path: '/hjelp/tinglysing-med-vedlegg/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserHjelpTresidigSkjoteIndexRoute =
  AuthenticatedUserHjelpTresidigSkjoteIndexRouteImport.update({
    id: '/hjelp/tresidig-skjote/',
    path: '/hjelp/tresidig-skjote/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute =
  AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRouteImport.update({
    id: '/hjelp/valideringsfeil-fra-kartverket/',
    path: '/hjelp/valideringsfeil-fra-kartverket/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserOppdragTluxCaseIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdIndexRouteImport.update({
    id: '/oppdrag/$tluxCaseId/',
    path: '/oppdrag/$tluxCaseId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSuperuserAfpantIndexRoute =
  AuthenticatedUserSuperuserAfpantIndexRouteImport.update({
    id: '/superuser/afpant/',
    path: '/superuser/afpant/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSuperuserRapporterIndexRoute =
  AuthenticatedUserSuperuserRapporterIndexRouteImport.update({
    id: '/superuser/rapporter/',
    path: '/superuser/rapporter/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSuperuserStatistikkIndexRoute =
  AuthenticatedUserSuperuserStatistikkIndexRouteImport.update({
    id: '/superuser/statistikk/',
    path: '/superuser/statistikk/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSuperuserTinglysingIndexRoute =
  AuthenticatedUserSuperuserTinglysingIndexRouteImport.update({
    id: '/superuser/tinglysing/',
    path: '/superuser/tinglysing/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRouteImport.update(
    {
      id: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/',
      path: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRouteImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-sikring/',
    path: '/oppdrag/$tluxCaseId/opprett-sikring/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRouteImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-skjøte/',
    path: '/oppdrag/$tluxCaseId/opprett-skjøte/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRouteImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-sletting/',
    path: '/oppdrag/$tluxCaseId/opprett-sletting/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberIndexRouteImport.update({
    id: '/superuser/afpant/$orgNumber/',
    path: '/superuser/afpant/$orgNumber/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRouteImport.update(
    {
      id: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/',
      path: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRouteImport.update({
    id: '/oppdrag/$tluxCaseId/sikring/$sikringId/',
    path: '/oppdrag/$tluxCaseId/sikring/$sikringId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRouteImport.update(
    {
      id: '/oppdrag/$tluxCaseId/skjøte/$skjoeteId/',
      path: '/oppdrag/$tluxCaseId/skjøte/$skjoeteId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRouteImport.update({
    id: '/oppdrag/$tluxCaseId/sletting/$slettingId/',
    path: '/oppdrag/$tluxCaseId/sletting/$slettingId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)
const AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRouteImport.update(
    {
      id: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/',
      path: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRouteImport.update(
    {
      id: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/',
      path: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRouteImport.update(
    {
      id: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/',
      path: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRouteImport.update(
    {
      id: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/',
      path: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRouteImport.update(
    {
      id: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/',
      path: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )
const AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRouteImport.update(
    {
      id: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/',
      path: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login/': typeof LoginIndexRoute
  '/ny-bruker/': typeof NyBrukerIndexRoute
  '/signer/': typeof AuthenticatedActorSignerIndexRoute
  '/hjelp/': typeof AuthenticatedUserHjelpIndexRoute
  '/sms-meldinger/': typeof AuthenticatedUserSmsMeldingerIndexRoute
  '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/': typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute
  '/hjelp/dodsbo-hjemmelserklaering/': typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute
  '/hjelp/kom-i-gang/': typeof AuthenticatedUserHjelpKomIGangIndexRoute
  '/hjelp/saker-som-ikke-kan-sendes-elektronisk/': typeof AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute
  '/hjelp/tinglysing-med-vedlegg/': typeof AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute
  '/hjelp/tresidig-skjote/': typeof AuthenticatedUserHjelpTresidigSkjoteIndexRoute
  '/hjelp/valideringsfeil-fra-kartverket/': typeof AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute
  '/oppdrag/$tluxCaseId/': typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  '/superuser/afpant/': typeof AuthenticatedUserSuperuserAfpantIndexRoute
  '/superuser/rapporter/': typeof AuthenticatedUserSuperuserRapporterIndexRoute
  '/superuser/statistikk/': typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  '/superuser/tinglysing/': typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sikring/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-skjøte/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sletting/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  '/superuser/afpant/$orgNumber/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/': typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute
  '/oppdrag/$tluxCaseId/sikring/$sikringId/': typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  '/oppdrag/$tluxCaseId/skjøte/$skjoeteId/': typeof AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute
  '/oppdrag/$tluxCaseId/sletting/$slettingId/': typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginIndexRoute
  '/ny-bruker': typeof NyBrukerIndexRoute
  '/signer': typeof AuthenticatedActorSignerIndexRoute
  '/hjelp': typeof AuthenticatedUserHjelpIndexRoute
  '/sms-meldinger': typeof AuthenticatedUserSmsMeldingerIndexRoute
  '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest': typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute
  '/hjelp/dodsbo-hjemmelserklaering': typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute
  '/hjelp/kom-i-gang': typeof AuthenticatedUserHjelpKomIGangIndexRoute
  '/hjelp/saker-som-ikke-kan-sendes-elektronisk': typeof AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute
  '/hjelp/tinglysing-med-vedlegg': typeof AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute
  '/hjelp/tresidig-skjote': typeof AuthenticatedUserHjelpTresidigSkjoteIndexRoute
  '/hjelp/valideringsfeil-fra-kartverket': typeof AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute
  '/oppdrag/$tluxCaseId': typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  '/superuser/afpant': typeof AuthenticatedUserSuperuserAfpantIndexRoute
  '/superuser/rapporter': typeof AuthenticatedUserSuperuserRapporterIndexRoute
  '/superuser/statistikk': typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  '/superuser/tinglysing': typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring': typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sikring': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-skjøte': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sletting': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  '/superuser/afpant/$orgNumber': typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId': typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute
  '/oppdrag/$tluxCaseId/sikring/$sikringId': typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  '/oppdrag/$tluxCaseId/skjøte/$skjoeteId': typeof AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute
  '/oppdrag/$tluxCaseId/sletting/$slettingId': typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId': typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId': typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated-actor': typeof AuthenticatedActorRouteWithChildren
  '/_authenticated-user': typeof AuthenticatedUserRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/ny-bruker/': typeof NyBrukerIndexRoute
  '/_authenticated-actor/signer/': typeof AuthenticatedActorSignerIndexRoute
  '/_authenticated-user/hjelp/': typeof AuthenticatedUserHjelpIndexRoute
  '/_authenticated-user/sms-meldinger/': typeof AuthenticatedUserSmsMeldingerIndexRoute
  '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/': typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute
  '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering/': typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute
  '/_authenticated-user/hjelp/kom-i-gang/': typeof AuthenticatedUserHjelpKomIGangIndexRoute
  '/_authenticated-user/hjelp/saker-som-ikke-kan-sendes-elektronisk/': typeof AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute
  '/_authenticated-user/hjelp/tinglysing-med-vedlegg/': typeof AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute
  '/_authenticated-user/hjelp/tresidig-skjote/': typeof AuthenticatedUserHjelpTresidigSkjoteIndexRoute
  '/_authenticated-user/hjelp/valideringsfeil-fra-kartverket/': typeof AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/': typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  '/_authenticated-user/superuser/afpant/': typeof AuthenticatedUserSuperuserAfpantIndexRoute
  '/_authenticated-user/superuser/rapporter/': typeof AuthenticatedUserSuperuserRapporterIndexRoute
  '/_authenticated-user/superuser/statistikk/': typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  '/_authenticated-user/superuser/tinglysing/': typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/': typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/': typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjoeteId/': typeof AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/': typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login/'
    | '/ny-bruker/'
    | '/signer/'
    | '/hjelp/'
    | '/sms-meldinger/'
    | '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/'
    | '/hjelp/dodsbo-hjemmelserklaering/'
    | '/hjelp/kom-i-gang/'
    | '/hjelp/saker-som-ikke-kan-sendes-elektronisk/'
    | '/hjelp/tinglysing-med-vedlegg/'
    | '/hjelp/tresidig-skjote/'
    | '/hjelp/valideringsfeil-fra-kartverket/'
    | '/oppdrag/$tluxCaseId/'
    | '/superuser/afpant/'
    | '/superuser/rapporter/'
    | '/superuser/statistikk/'
    | '/superuser/tinglysing/'
    | '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/'
    | '/oppdrag/$tluxCaseId/opprett-sikring/'
    | '/oppdrag/$tluxCaseId/opprett-skjøte/'
    | '/oppdrag/$tluxCaseId/opprett-sletting/'
    | '/superuser/afpant/$orgNumber/'
    | '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/'
    | '/oppdrag/$tluxCaseId/sikring/$sikringId/'
    | '/oppdrag/$tluxCaseId/skjøte/$skjoeteId/'
    | '/oppdrag/$tluxCaseId/sletting/$slettingId/'
    | '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/'
    | '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/'
    | '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/'
    | '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/'
    | '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/'
    | '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/ny-bruker'
    | '/signer'
    | '/hjelp'
    | '/sms-meldinger'
    | '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest'
    | '/hjelp/dodsbo-hjemmelserklaering'
    | '/hjelp/kom-i-gang'
    | '/hjelp/saker-som-ikke-kan-sendes-elektronisk'
    | '/hjelp/tinglysing-med-vedlegg'
    | '/hjelp/tresidig-skjote'
    | '/hjelp/valideringsfeil-fra-kartverket'
    | '/oppdrag/$tluxCaseId'
    | '/superuser/afpant'
    | '/superuser/rapporter'
    | '/superuser/statistikk'
    | '/superuser/tinglysing'
    | '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring'
    | '/oppdrag/$tluxCaseId/opprett-sikring'
    | '/oppdrag/$tluxCaseId/opprett-skjøte'
    | '/oppdrag/$tluxCaseId/opprett-sletting'
    | '/superuser/afpant/$orgNumber'
    | '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId'
    | '/oppdrag/$tluxCaseId/sikring/$sikringId'
    | '/oppdrag/$tluxCaseId/skjøte/$skjoeteId'
    | '/oppdrag/$tluxCaseId/sletting/$slettingId'
    | '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId'
    | '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId'
    | '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId'
    | '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId'
    | '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId'
    | '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated-actor'
    | '/_authenticated-user'
    | '/login/'
    | '/ny-bruker/'
    | '/_authenticated-actor/signer/'
    | '/_authenticated-user/hjelp/'
    | '/_authenticated-user/sms-meldinger/'
    | '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/'
    | '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering/'
    | '/_authenticated-user/hjelp/kom-i-gang/'
    | '/_authenticated-user/hjelp/saker-som-ikke-kan-sendes-elektronisk/'
    | '/_authenticated-user/hjelp/tinglysing-med-vedlegg/'
    | '/_authenticated-user/hjelp/tresidig-skjote/'
    | '/_authenticated-user/hjelp/valideringsfeil-fra-kartverket/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/'
    | '/_authenticated-user/superuser/afpant/'
    | '/_authenticated-user/superuser/rapporter/'
    | '/_authenticated-user/superuser/statistikk/'
    | '/_authenticated-user/superuser/tinglysing/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjoeteId/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedActorRoute: typeof AuthenticatedActorRouteWithChildren
  AuthenticatedUserRoute: typeof AuthenticatedUserRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
  NyBrukerIndexRoute: typeof NyBrukerIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-actor': {
      id: '/_authenticated-actor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedActorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-user': {
      id: '/_authenticated-user'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedUserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ny-bruker/': {
      id: '/ny-bruker/'
      path: '/ny-bruker'
      fullPath: '/ny-bruker/'
      preLoaderRoute: typeof NyBrukerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-actor/signer/': {
      id: '/_authenticated-actor/signer/'
      path: '/signer'
      fullPath: '/signer/'
      preLoaderRoute: typeof AuthenticatedActorSignerIndexRouteImport
      parentRoute: typeof AuthenticatedActorRoute
    }
    '/_authenticated-user/hjelp/': {
      id: '/_authenticated-user/hjelp/'
      path: '/hjelp'
      fullPath: '/hjelp/'
      preLoaderRoute: typeof AuthenticatedUserHjelpIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/sms-meldinger/': {
      id: '/_authenticated-user/sms-meldinger/'
      path: '/sms-meldinger'
      fullPath: '/sms-meldinger/'
      preLoaderRoute: typeof AuthenticatedUserSmsMeldingerIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/': {
      id: '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/'
      path: '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest'
      fullPath: '/hjelp/dodsbo-hjemmelserklaering-og-skifteattest/'
      preLoaderRoute: typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering/': {
      id: '/_authenticated-user/hjelp/dodsbo-hjemmelserklaering/'
      path: '/hjelp/dodsbo-hjemmelserklaering'
      fullPath: '/hjelp/dodsbo-hjemmelserklaering/'
      preLoaderRoute: typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/kom-i-gang/': {
      id: '/_authenticated-user/hjelp/kom-i-gang/'
      path: '/hjelp/kom-i-gang'
      fullPath: '/hjelp/kom-i-gang/'
      preLoaderRoute: typeof AuthenticatedUserHjelpKomIGangIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/saker-som-ikke-kan-sendes-elektronisk/': {
      id: '/_authenticated-user/hjelp/saker-som-ikke-kan-sendes-elektronisk/'
      path: '/hjelp/saker-som-ikke-kan-sendes-elektronisk'
      fullPath: '/hjelp/saker-som-ikke-kan-sendes-elektronisk/'
      preLoaderRoute: typeof AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/tinglysing-med-vedlegg/': {
      id: '/_authenticated-user/hjelp/tinglysing-med-vedlegg/'
      path: '/hjelp/tinglysing-med-vedlegg'
      fullPath: '/hjelp/tinglysing-med-vedlegg/'
      preLoaderRoute: typeof AuthenticatedUserHjelpTinglysingMedVedleggIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/tresidig-skjote/': {
      id: '/_authenticated-user/hjelp/tresidig-skjote/'
      path: '/hjelp/tresidig-skjote'
      fullPath: '/hjelp/tresidig-skjote/'
      preLoaderRoute: typeof AuthenticatedUserHjelpTresidigSkjoteIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/hjelp/valideringsfeil-fra-kartverket/': {
      id: '/_authenticated-user/hjelp/valideringsfeil-fra-kartverket/'
      path: '/hjelp/valideringsfeil-fra-kartverket'
      fullPath: '/hjelp/valideringsfeil-fra-kartverket/'
      preLoaderRoute: typeof AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/'
      path: '/oppdrag/$tluxCaseId'
      fullPath: '/oppdrag/$tluxCaseId/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/': {
      id: '/_authenticated-user/superuser/afpant/'
      path: '/superuser/afpant'
      fullPath: '/superuser/afpant/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/rapporter/': {
      id: '/_authenticated-user/superuser/rapporter/'
      path: '/superuser/rapporter'
      fullPath: '/superuser/rapporter/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserRapporterIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/statistikk/': {
      id: '/_authenticated-user/superuser/statistikk/'
      path: '/superuser/statistikk'
      fullPath: '/superuser/statistikk/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserStatistikkIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/tinglysing/': {
      id: '/_authenticated-user/superuser/tinglysing/'
      path: '/superuser/tinglysing'
      fullPath: '/superuser/tinglysing/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserTinglysingIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/'
      path: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring'
      fullPath: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/'
      path: '/oppdrag/$tluxCaseId/opprett-sikring'
      fullPath: '/oppdrag/$tluxCaseId/opprett-sikring/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/'
      path: '/oppdrag/$tluxCaseId/opprett-skjøte'
      fullPath: '/oppdrag/$tluxCaseId/opprett-skjøte/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/'
      path: '/oppdrag/$tluxCaseId/opprett-sletting'
      fullPath: '/oppdrag/$tluxCaseId/opprett-sletting/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/'
      path: '/superuser/afpant/$orgNumber'
      fullPath: '/superuser/afpant/$orgNumber/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/'
      path: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId'
      fullPath: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/'
      path: '/oppdrag/$tluxCaseId/sikring/$sikringId'
      fullPath: '/oppdrag/$tluxCaseId/sikring/$sikringId/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjoeteId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjoeteId/'
      path: '/oppdrag/$tluxCaseId/skjøte/$skjoeteId'
      fullPath: '/oppdrag/$tluxCaseId/skjøte/$skjoeteId/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/'
      path: '/oppdrag/$tluxCaseId/sletting/$slettingId'
      fullPath: '/oppdrag/$tluxCaseId/sletting/$slettingId/'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/'
      path: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId'
      fullPath: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/'
      path: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId'
      fullPath: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/'
      path: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId'
      fullPath: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/'
      path: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId'
      fullPath: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/'
      path: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId'
      fullPath: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/'
      path: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId'
      fullPath: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserRoute
    }
  }
}

interface AuthenticatedActorRouteChildren {
  AuthenticatedActorSignerIndexRoute: typeof AuthenticatedActorSignerIndexRoute
}

const AuthenticatedActorRouteChildren: AuthenticatedActorRouteChildren = {
  AuthenticatedActorSignerIndexRoute: AuthenticatedActorSignerIndexRoute,
}

const AuthenticatedActorRouteWithChildren =
  AuthenticatedActorRoute._addFileChildren(AuthenticatedActorRouteChildren)

interface AuthenticatedUserRouteChildren {
  AuthenticatedUserHjelpIndexRoute: typeof AuthenticatedUserHjelpIndexRoute
  AuthenticatedUserSmsMeldingerIndexRoute: typeof AuthenticatedUserSmsMeldingerIndexRoute
  AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute: typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute
  AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute: typeof AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute
  AuthenticatedUserHjelpKomIGangIndexRoute: typeof AuthenticatedUserHjelpKomIGangIndexRoute
  AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute: typeof AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute
  AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute: typeof AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute
  AuthenticatedUserHjelpTresidigSkjoteIndexRoute: typeof AuthenticatedUserHjelpTresidigSkjoteIndexRoute
  AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute: typeof AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute
  AuthenticatedUserOppdragTluxCaseIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  AuthenticatedUserSuperuserAfpantIndexRoute: typeof AuthenticatedUserSuperuserAfpantIndexRoute
  AuthenticatedUserSuperuserRapporterIndexRoute: typeof AuthenticatedUserSuperuserRapporterIndexRoute
  AuthenticatedUserSuperuserStatistikkIndexRoute: typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  AuthenticatedUserSuperuserTinglysingIndexRoute: typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute
  AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute
  AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}

const AuthenticatedUserRouteChildren: AuthenticatedUserRouteChildren = {
  AuthenticatedUserHjelpIndexRoute: AuthenticatedUserHjelpIndexRoute,
  AuthenticatedUserSmsMeldingerIndexRoute:
    AuthenticatedUserSmsMeldingerIndexRoute,
  AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute:
    AuthenticatedUserHjelpDodsboHjemmelserklaeringOgSkifteattestIndexRoute,
  AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute:
    AuthenticatedUserHjelpDodsboHjemmelserklaeringIndexRoute,
  AuthenticatedUserHjelpKomIGangIndexRoute:
    AuthenticatedUserHjelpKomIGangIndexRoute,
  AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute:
    AuthenticatedUserHjelpSakerSomIkkeKanSendesElektroniskIndexRoute,
  AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute:
    AuthenticatedUserHjelpTinglysingMedVedleggIndexRoute,
  AuthenticatedUserHjelpTresidigSkjoteIndexRoute:
    AuthenticatedUserHjelpTresidigSkjoteIndexRoute,
  AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute:
    AuthenticatedUserHjelpValideringsfeilFraKartverketIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdIndexRoute,
  AuthenticatedUserSuperuserAfpantIndexRoute:
    AuthenticatedUserSuperuserAfpantIndexRoute,
  AuthenticatedUserSuperuserRapporterIndexRoute:
    AuthenticatedUserSuperuserRapporterIndexRoute,
  AuthenticatedUserSuperuserStatistikkIndexRoute:
    AuthenticatedUserSuperuserStatistikkIndexRoute,
  AuthenticatedUserSuperuserTinglysingIndexRoute:
    AuthenticatedUserSuperuserTinglysingIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklChar230ringIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettSkjChar248teIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdHjemmelserklChar230ringHjemmelserklaeringIdIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdSkjChar248teSkjoeteIdIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute,
}

const AuthenticatedUserRouteWithChildren =
  AuthenticatedUserRoute._addFileChildren(AuthenticatedUserRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedActorRoute: AuthenticatedActorRouteWithChildren,
  AuthenticatedUserRoute: AuthenticatedUserRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
  NyBrukerIndexRoute: NyBrukerIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
